import React, { useState } from 'react'

// styles 
import {
	LoginContainer,
	Heading,
	PageLinking,
	Button
} from "./styles";

// form input
import AppFormikInput from "utlis/helpers/forms/AppFormikInput";

// bootstrap
import { Link } from 'react-router-dom';

export default function Register(props) {
	// props
	const {
		formik,

		buttonLoading,
		buttonDisable
	} = props

	return (
		<LoginContainer className="container">
			<div className="d-flex flex-wrap mx-auto mb-3 login-inner">
				{/* left side */}
				<div className="col-sm-6 col-12 pe-sm-3">
					<div className="pb-3">
						{/* <Heading>Join us or sign in</Heading> */}
						<Heading>Join Us</Heading>
						<PageLinking>
							<span>Store</span> &ensp;/&ensp; <span>Join Us</span>
						</PageLinking>
					</div>
					<div className="st-fs-17">
						Track your future orders, checkout faster, and sync your favorites.
						Just create an account with us and you'll be able to do that.
					</div>
				</div>

				{/* Right side */}
				<div className="col-sm-6 col-12 ps-sm-3">
					<div className="pt-5">
						<form onSubmit={formik.handleSubmit} noValidate autoComplete="off">
							<AppFormikInput
								inputType={"text"}
								formik={formik} // formik object
								stFormClass={"ct w-100 mb-2"} // class name for main wrapper
								isRequired={true} // is this field is required or not to show the red star sign
								placeholder={"First Name"} // placeholder for the input
								labelName={"First Name"}
								formikFieldName={"firstName"} // important: formik value name for the input
							/>

							<AppFormikInput
								inputType={"text"}
								formik={formik} // formik object
								stFormClass={"ct w-100 mb-2"} // class name for main wrapper
								isRequired={true} // is this field is required or not to show the red star sign
								placeholder={"Last Name"} // placeholder for the input
								labelName={"Last Name"}
								formikFieldName={"lastName"} // important: formik value name for the input
							/>

							<AppFormikInput
								inputType={"email"}
								formik={formik} // formik object
								stFormClass={"ct w-100 mb-2"} // class name for main wrapper
								isRequired={true} // is this field is required or not to show the red star sign
								placeholder={"Email"} // placeholder for the input
								labelName={"Email"}
								formikFieldName={"email"} // important: formik value name for the input
							/>

							<AppFormikInput
								inputType={"number"}
								formik={formik} // formik object
								stFormClass={"ct w-100 no-arrows mb-2"} // class name for main wrapper
								isRequired={true} // is this field is required or not to show the red star sign
								placeholder={"Phone"} // placeholder for the input
								labelName={"Phone"}
								formikFieldName={"phone"} // important: formik value name for the input
							/>

							<AppFormikInput
								inputType={"password"}
								formik={formik} // formik object
								stFormClass={"ct w-100 mb-2"} // class name for main wrapper
								isRequired={true} // is this field is required or not to show the red star sign
								placeholder={"Password"} // placeholder for the input
								labelName={"Password"}
								formikFieldName={"password"} // important: formik value name for the input
							/>

							<div className="btns d-flex justify-content-center pt-3">
								<Button type="submit" disabled={buttonDisable} className="mb-0">
									{buttonLoading ? (
										<div
											className="spinner-border spinner-border-sm"
											role="status"
										/>
									) : (
										<span>Create Account</span>
									)}
								</Button>
							</div>

							<div className="info text-center position-relative mt-3">
								<span className="st-fs-16">
									Already have an account?
								</span>
								<Link to="/login" className="ms-2 st-fs-16 st-fw-600 hover-underline-link">Sign In</Link>
							</div>
						</form>
					</div>
				</div>
			</div>

		</LoginContainer>
	)
}
